import React from "react";
import styled from "styled-components";
import whale from "../Asset/Icons/whale.png";
import chrome from "../Asset/Icons/chrome.png";

const Box = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2001;
  @media screen and (max-width: 560px) {
    flex-direction: column;
    padding: 10px;
  }
`;

const LinkCard = styled.a`
  display: flex;
  width: calc((100% - 10px) / 2);
  background-color: rgba(247, 247, 247, 1);
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  @media screen and (max-width: 560px) {
    width: 200px;
    margin-bottom: 10px;
  }
`;

const StoreIconBox = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

const StoreIcon = styled.img`
  width: 100%;
`;

const TextArea = styled.div`
  width: calc(100% - 46px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-family: GmarketSansMedium; */
`;

const LinkArea = () => {
  return (
    <Box className="disableDrag">
      <LinkCard
        href="https://store.whale.naver.com/detail/lcdoehiggfaemkopahjhckkfnpmkhpah?hl=ko"
        target="_blank"
      >
        <StoreIconBox>
          <StoreIcon src={whale}></StoreIcon>
        </StoreIconBox>
        <TextArea>웨일 스토어 가기</TextArea>
      </LinkCard>
      <LinkCard
        href="https://chrome.google.com/webstore/detail/cutify-%ED%81%90%ED%8B%B0%ED%8C%8C%EC%9D%B4/lgjpbnljfbeibichnannkdkniodcgmen?hl=ko"
        target="_blank"
      >
        <StoreIconBox>
          <StoreIcon src={chrome}></StoreIcon>
        </StoreIconBox>
        <TextArea>크롬 스토어 가기</TextArea>
      </LinkCard>
    </Box>
  );
};

export default LinkArea;
